var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDisclaimer = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19808"
}, /*#__PURE__*/React.createElement("g", {
  fill: "none",
  "data-name": "Group 19800",
  transform: "translate(-40 -401.719)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  "data-name": "Ellipse 1639",
  transform: "translate(40 401.719)"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  "data-name": "Group 19770"
}, /*#__PURE__*/React.createElement("path", {
  d: "m67.935 423.76-4.939-8.979a3.418 3.418 0 0 0-5.989 0l-4.938 8.979a3.417 3.417 0 0 0 2.994 5.064h9.878a3.417 3.417 0 0 0 2.994-5.064",
  "data-name": "Path 27422"
}), /*#__PURE__*/React.createElement("path", {
  d: "M60.001 424.925",
  "data-name": "Line 1704"
}), /*#__PURE__*/React.createElement("path", {
  d: "M60.001 417.91v4.872",
  "data-name": "Line 1705"
}))))));
export { SvgDisclaimer as ReactComponent };
export default __webpack_public_path__ + "static/media/disclaimer.64d0a15ee760db8d3794f1edd9b79315.svg";